import { useState, useEffect } from 'react';
import { bool, number } from 'prop-types';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import * as styles from './styles/styles.module.scss';

const TrailEditHistory = ({ trailId, visible }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(null);

  useEffect(() => {
    if (visible && loading === null) {
      setLoading(true);
      ServerCommunicationUtil.getApiEndpoint(
        `/api/alltrails/admin/trails/${trailId}/history`,
        {},
        json => setHistory(json),
        err => console.log(err),
        () => setLoading(false)
      );
    }
  }, [visible]);

  const renderLoadingState = () => (
    <div className={styles.container}>
      <p>Loading...</p>
    </div>
  );

  if (loading) {
    return renderLoadingState();
  }

  const header = (
    <tr>
      <th>Field</th>
      <th>Date</th>
      <th>Admin</th>
      <th>User</th>
      <th>Approver</th>
      <th>Approved</th>
      <th>New Value</th>
    </tr>
  );
  const rows = history.map((change, index) => {
    return (
      <tr key={`${change.id}-${index}`}>
        <td>{change.name}</td>
        <td>{change.date}</td>
        <td>{change.userType}</td>
        <td>{change.user}</td>
        <td>{change.approver} {change.approvalInferred && "**"}</td>
        <td>{change.approvedDate}</td>
        <td>{change.value}</td>
      </tr>
    );
  });
  return (
    <div className={styles.container}>
      <table>
        <thead>
          {header}
        </thead>
        <tbody>
          {rows}
        </tbody>
      </table>
    </div>
  );
};

TrailEditHistory.propTypes = {
  trailId: number.isRequired,
  visible: bool.isRequired
};

export default TrailEditHistory;
